<template>
  <div class=''>
    登录
  </div>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from "vuex"
import {loginParams,registParams} from "../common/query"
import router from "@/router"

export default {
  name: '',
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {
    ...mapActions({
      login:"user/login",
      selectUserInfo:"user/selectUserInfo",
    })
  },
  created() {
      this.login()
  },
  mounted() {
  },
  beforeDestroy() {},
  components: {},
  filters: {}
};
</script>
<style lang='scss' scoped>
</style>